// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.tab-selector {
  font-family: "DM Sans", sans-serif !important;
  transition: all 0.5s;
  height: 31px;
  padding: 0 10px;
  border-radius: 10px;
  background: #FFF;
  box-shadow: 0px 4px 4px 0px rgba(58, 45, 71, 0.33);
  color: #8E8E8E;
  text-align: center;
  font-family: Rounded Mplus 1c Bold;
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  margin-right: 10px;
}
.tab-selector:hover {
  box-shadow: 0px 10px 10px 0px rgba(60, 44, 74, 0.15);
}`, "",{"version":3,"sources":["webpack://./src/views/admin/journal/components/TabSelector/TabSelector.scss"],"names":[],"mappings":"AAAA;EACE,6CAAA;EACA,oBAAA;EAEA,YAAA;EACA,eAAA;EAEA,mBAAA;EACA,gBAAA;EACA,kDAAA;EACA,cAAA;EACA,kBAAA;EACA,kCAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,kBAAA;AAAF;AAEE;EACE,oDAAA;AAAJ","sourcesContent":[".tab-selector{\r\n  font-family: \"DM Sans\", sans-serif !important;\r\n  transition: all 0.5s;\r\n  font-size: 16px;\r\n  height: 31px;\r\n  padding: 0 10px;\r\n  // background: white;\r\n  border-radius: 10px;\r\n  background: #FFF;\r\n  box-shadow: 0px 4px 4px 0px rgba(58, 45, 71, 0.33);\r\n  color: #8E8E8E;\r\n  text-align: center;\r\n  font-family: Rounded Mplus 1c Bold;\r\n  font-size: 16px;\r\n  font-style: normal;\r\n  font-weight: 700;\r\n  line-height: normal;\r\n  margin-right: 10px;\r\n\r\n  &:hover {\r\n    box-shadow: 0px 10px 10px 0px rgba(60, 44, 74, 0.15);\r\n  }\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
